import React, { Component } from 'react';
import { AppContext } from './../../AppContext';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { Solicitud_actividad } from './expand/Solicitud_actividad';
import { Solicitud_materia } from './expand/Solicitud_materia';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Col, Row, Container } from 'react-bootstrap';
import crear from './../img/svg/Nueva.svg';
import enviar from './../img/svg/Enviar(blanco).svg';


const API_URL = process.env.REACT_APP_API_URL;

function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
}
function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '15%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

function estaConformeFormatter(column, colIndex, { sortElement, filterElement }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '60px' }}>
            { filterElement}
            { column.text}
            { sortElement}
        </div>
    );

}

function desgloseHoras(termino, periodicidad, numhoras, totalhoras) {
    if (periodicidad !== "ANUAL") {
        if (termino === "1") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 20;

        } else if (termino === "2") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 20;

        } else if (termino === "3") {
            return periodicidad === "SEMESTRAL" ? numhoras : numhoras * 8;
        }
    } else {
        return totalhoras;
    }
}

export class Docencia_Postgrado_out extends Component {
    static displayName = Docencia_Postgrado_out.name;

    abortController = new window.AbortController();

    static totalmat = 0;
    static totalact = 0;

    handleBtnClick = () => {
        if (!this.state.expanded.includes(0)) {
            this.setState(() => ({
                expanded: [...this.state.expanded, 0]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded: [...this.state.expanded, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== row.id)
            }));
        }
    }

    handleBtnClick_mat = () => {
        if (!this.state.expanded_mat.includes(0)) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, 0]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand_mat = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== row.id)
            }));
        }
    }


    constructor(props) {
        super(props);
        
        this.state = {
            actividades: [], solicitudes: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            },
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ],
            materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            }, loading: false, loading2: false, loading3: false, expanded: [], expanded_mat: [], total: 0,
            materia_elegida: [
                { idcurso: 0, validada: "", estado_actividad: "" }
            ],
            anio: props.anio, idpersona: props.idprof,
            materia_elegida: [
                { idcurso: 0, validada: "", estado_actividad: "" }
            ],
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ], actividades_combo: [], periodo: "", newactividad: "", observacion: "",
            nuevoregistro: [], selectact: "", selectidact: "", abierto: false, fila_mat: [], fila: []
        };
        this.onInputChange = this.onInputChange.bind(this);


        this.onChangePao = this.onChangePao.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNew = this.handleNew.bind(this);

        this.updatestate = this.updatestate.bind(this);
        this.updatestate_mat = this.updatestate_mat.bind(this);
    }

    componentDidMount() {
        if (this.state.idpersona > 0) {
            this.populateActividadesData(this.state.idpersona, this.state.anio);
            this.populateMateriasData(this.state.idpersona, this.state.anio);
            this.populateActividadesCombo(this.state.idpersona, this.state.anio);
        }
    }

    componentWillUnmount() {
        try { this.abortController.abort('unmount'); } catch (_) { }
    }

    onInputChange(event) {
        var control = event.target.name;
        if (control === "busqueda") {
            var value = this.state.busqueda;
            value = event.target.value;
            this.setState({
                busqueda: value
            });
        }
        else {
            var uActividad = this.state.actividad;
            value = event.target.value;
            uActividad[control] = value;
            this.setState({
                actividad: uActividad
            });
        }
    }


    get_radios(termino1, termino2, termino3, anio) {
        var respu;
        if (termino2 === "2" && termino1 === "1" && termino3 === "0") {
            return (
                'PAE-' + anio + '\n  PAO-' + anio + '-1\n PAO-' + anio + '-2'
            )
        }
        else if (termino1 === "1") {
            if (termino1 === "1" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-1 \nPAE-' + anio
                );
            } else if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1 \nPAO-' + anio + '-2'
                );

            } else {
                return (
                    'PAO-' + anio + '-1'
                );
            }
        } else if (termino2 === "2") {
            if (termino2 === "2" && termino1 === "1") {
                return (
                    'PAO-' + anio + '-1\n PAO-' + anio + '-2'
                );

            } else if (termino2 === "2" && termino3 === "0") {
                return (
                    'PAO-' + anio + '-2\n PAE-' + anio
                );
            }
            return (
                'PAO-' + anio + '-2'
            );
        } else if (termino3 === "0") {
            if (termino3 === "0" && termino1 === "1") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-1'
                );

            } else if (termino3 === "0" && termino2 === "2") {
                return (
                    'PAE-' + anio + '\n PAO-' + anio + '-2'
                );
            }
            return (
                'PAE-' + anio
            );
        }
    }

    updatestate(idactividad, descripcion, totalhoras, anio, termino, tipoactividad, observacion, pao1, pao2, pae, accion) {
        //const terminos = this.get_radios(pao1, pao2, pae, anio)
        var solicitudes = this.state.solicitudes
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idactividad)
        }

        solicitudes.push({
            idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion
        })
        this.setState({
            solicitudes: solicitudes
        });

        this.props.update({ ambito: 'A|P', idactividad: idactividad, observacion: observacion, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: termino, tipoactividad: tipoactividad, pao1: pao1, pao2: pao2, pae: pae, accion: accion});

    }

    updatestate_mat(idcurso, descripcion, observacion, anio, termino, totalhoras, accion) {
        var solicitudes = this.state.solicitudes
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idcurso)
        }

        solicitudes.push({
            idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, totalhoras: totalhoras, termino: termino, accion: accion
        })
        this.setState({
            solicitudes: solicitudes
        });

        this.props.update({ ambito: 'M|P', idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, tipoactividad: 'D', totalhoras: totalhoras, termino: termino, accion: accion})
        
    }

    /////FUNCIONES para interactuar con los si/no de ACtividades
    handleHideClick = (idactividad) => {
        let obj = this.state.fila.find((o, i) => {
            if (o.idactividad === idactividad) {
                this.state.fila[i].validacion = 'si'
                return this.state.fila[i];
            }
        });
        if (obj == null) {
            this.state.fila.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        }
        if (this.state.expanded.includes(idactividad)) {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== idactividad)
            }));
        }
        //console.log(this.state.fila);

    }

    handleShowClick = (idactividad) => {


        //console.log(idactividad)
        if (!this.state.expanded.includes(idactividad)) {

            let obj = this.state.fila.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila[i].validacion = 'no'
                    return this.state.fila[i];
                }
            });
            if (obj == null) {
                this.state.fila.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded: [...this.state.expanded, idactividad]
            }));
        }
        //console.log(this.state.fila);
    }

    handleHideAllClick = () => {

        let filas = [];

        this.state.actividades.forEach((element) => {
            filas.push({
                idactividad: element.idactividad,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded: [],
            fila: filas
        }));
        //console.log(this.state.fila);
        this.handleAllCheck()
    }

    handleShowAllClick = () => {

        let filas = [];
        let expandir = [];
        this.state.actividades.forEach((element) => {
            filas.push({
                idactividad: element.idactividad,
                validacion: 'no'
            });
            if (!this.state.expanded.includes(element.idactividad)) {
                expandir.push(element.idactividad);
            }
        })
        this.setState(() => ({
            expanded: this.state.expanded.concat(expandir),
            fila: filas
        }));
        //console.log(this.state.fila);
        //console.log(this.state.actividades);
        this.handleAllCheck()
        //console.log('ACTIVIDAD:' + this.state.fila);
        //console.log('ACTIVIDAD:' + this.state.actividades);
    }

    handleAllCheck() {
        //console.log(this.state.fila);
        const check = document.getElementsByName("all_apg");
        const checkSin = document.getElementById("Actividades_Postg").getElementsByClassName('form-check-input');
        //console.log(check);
        //console.log(checkSin);
        if (check[0].checked) {
            //console.log('Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "1") {
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        } else {

            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "0") {
                    //console.log('Nou');
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        }
    }

    /////FUNCIONES para interactuar con los si/no de Materias
    handleHideClick_mat = (idactividad) => {
        let obj = this.state.fila_mat.find((o, i) => {
            if (o.idactividad === idactividad) {
                this.state.fila_mat[i].validacion = 'si'
                return this.state.fila_mat[i];
            }
        });
        if (obj == null) {
            this.state.fila_mat.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        }
        if (this.state.expanded_mat.includes(idactividad)) {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== idactividad)
            }));
        }
        //console.log('MATERIA:' + this.state.fila_mat);

    }

    handleShowClick_mat = (idactividad) => {


        //console.log('MATERIA:' + idactividad)
        if (!this.state.expanded_mat.includes(idactividad)) {

            let obj = this.state.fila_mat.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila_mat[i].validacion = 'no'
                    return this.state.fila_mat[i];
                }
            });
            if (obj == null) {
                this.state.fila_mat.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, idactividad]
            }));
        }
        //console.log(this.state.fila_mat);
    }

    handleHideAllClick_mat = () => {

        let filas = [];

        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idcplpostgrados,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded_mat: [],
            fila_mat: filas
        }));
        //console.log(this.state.expanded_mat);
        this.handleAllCheck_mat()
    }

    handleShowAllClick_mat = () => {

        let filas = [];
        let expandir = [];
        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idcplpostgrados,
                validacion: 'no'
            });
            if (!this.state.expanded_mat.includes(element.idcplpostgrados)) {
                expandir.push(element.idcplpostgrados);
            }
        })
        this.setState(() => ({
            expanded_mat: this.state.expanded_mat.concat(expandir),
            fila_mat: filas
        }));
        //console.log('MATERIA:' + this.state.fila_mat);
        //console.log('MATERIA:' + this.state.materias);
        this.handleAllCheck_mat()
    }

    handleAllCheck_mat() {
        //console.log('MATERIA:' + this.state.fila_mat);
        const check = document.getElementsByName("all_mpg");
        const checkSin = document.getElementById("Materias_Postg").getElementsByClassName('form-check-input');
        //console.log('MATERIA:' + check);
        //console.log('MATERIA:' + checkSin);
        if (check[0].checked) {
            //console.log('MATERIA:' + 'Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "1") {
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        } else {

            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "0") {
                    //console.log('Nou');
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
        }
    }

    renderActividadesTable(actividades) {
        var actividades_split = [];

        actividades.map((act, index) => {
            if (act.termino3 === "0") {
                var thoras3 = desgloseHoras(act.termino3, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '0',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": null,
                    "termino2": null,
                    "termino3": act.termino3,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino3
                });
            }

            if (act.termino1 === "1") {
                var thoras1 = desgloseHoras(act.termino1, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '1',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": act.termino1,
                    "termino2": null,
                    "termino3": null,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino1
                });
            }

            if (act.termino2 === "2") {
                var thoras2 = desgloseHoras(act.termino2, act.periodicidad, act.numhoras, act.totalhoras);
                actividades_split.push({
                    "actividad": act.actividad,
                    "anio": act.anio,
                    "descripcion": act.descripcion,
                    "escarga": act.escarga,
                    "estadocheck": act.estadocheck,
                    "idactividad": act.idactividad,
                    "idUnico": act.idactividad + '2',
                    "idtipoactividad": act.idtipoactividad,
                    "nivelEstudio": act.nivelEstudio,
                    "numhoras": act.numhoras,
                    "periodicidad": act.periodicidad,
                    "termino1": null,
                    "termino2": act.termino2,
                    "termino3": null,
                    "tipoactividad": act.tipoactividad,
                    "totalhoras": act.horastermino2
                });
            }
        });

        var totalactividades = this.state.actividades ? this.state.actividades.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;

        const columns_acti = [
            {
                dataField: 'id',
                text: '#',

                footer: '',
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },
            {
                dataField: 'idactividad',
                text: '#',
                hidden: true,
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'idUnico',
                text: 'ID UNICO',
                hidden: true
            }, {
                dataField: 'actividad',
                text: 'Actividad',
                headerStyle: color_head_desc('d'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            }, {
                dataField: 'descripcion',
                text: 'Descripción',
                headerStyle: color_head_desc('a'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: ''
            },
            {
                dataField: 'termino1',
                text: 'Periodo',
                formatter: (cellContent, row) => {
                    if (row.termino1 === "1") {
                        return <>PAO {row.anio}-1</>

                    } else if (row.termino2 === "2") {
                        return <>PAO {row.anio}-2</>

                    } else if (row.termino3 === "0") {
                        return <>PAE {row.anio}</>
                    }
                },
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footer: 'Subtotal: '
            }, {
                dataField: 'totalhoras',
                text: 'Horas',
                headerStyle: color_head(),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                footerAlign: 'left',
                footer: () => {
                    return (<>{totalactividades.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
                }
            }];

        return (
            <>
                { actividades && actividades.length > 0 ?
                    <BootstrapTable
                        id="Actividades_Postg"
                        keyField='idUnico'
                        data={actividades_split}
                        columns={columns_acti}
                        bordered={false}
                    /> : null
                }
            </>

        );
    }




    renderMateriasTable(materias) {

        const columns_materias = [{
            dataField: 'id',
            text: '#',
            footer: '',

            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        {rowIndex + 1}
                    </div>
                )
            }
        }, {
            dataField: 'codigoCurso',
            text: 'Código',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'nomMateria',
            text: 'Asignatura',
            headerStyle: color_head_desc('a'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
            },
            {
            dataField: 'cohorte',
            text: 'Cohorte',
                headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
            },
            {
                dataField: 'fechaInicio',
                text: 'Fecha Inicio',
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => { 
                    return (
                        <div>
                            {row.fechaInicio.split('T')[0]}
                        </div>
                    )
                },
                footer: ''
        }, {
                dataField: 'fechaFin',
                text: 'Fecha Fin',
                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {row.fechaFin.split('T')[0]}
                        </div>
                    )
                },
                footer: ''
            },
        {
            dataField: 'paralelo',
            text: 'Paralelo',
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino',
            text: 'Periodo',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: (cellContent, row) => {
                var respu;
                if (row.termino.trim() === "1" || row.termino.trim() === "1S") {
                    return (
                        <>PAO-{row.anio}-1</>
                    );
                } else if (row.termino.trim() === "2" || row.termino.trim() === "2S") {
                    return (
                        <>PAO-{row.anio}-2</>
                    );

                } else if (row.termino.trim() === "3" || row.termino.trim() === "3S" || row.termino.trim() === "PAO-20220") {
                    return (
                        <>PAE-{row.anio}</>
                    );

                } else {

                    return (
                        <>{row.termino}</>
                    );
                }
            },
            footer: 'Subtotal: '
        }, {
            dataField: 'horasTotales',
            text: 'Horas',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footerAlign: 'left',
            footer: columnData2 => {
                const total1 = columnData2.reduce((acc2, item2) => (Number(acc2) + Number(item2)).toFixed(2), 0);
                return (<>{total1.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
            },
        }];
         
        return (
            <BootstrapTable
                id="Materias_Postg"
                keyField='idCplPostGrados'
                data={materias}
                columns={columns_materias}
                bordered={false} 
            />
        );

    
}


    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    handleChange(e) {
        var idactividad = e.target.value;
        var data = this.state.actividades_combo.filter(x => x.idactividad == idactividad).map(act => act.descripcion);

        this.setState({ selectact: data, selectidact: e.target.value });
    }

    handleSearch(event) {
        this.setState({ observacion: event.target.value });
        //console.log(this.state.observacion);
    }


    onChangePao(event) {
        this.setState({
            periodo: event.target.value
        })
        //console.log(this.state.periodo)
    }

    abrirModal = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    cerrarModal = () => {
        this.setState({ abierto: false });
    }

    handleNew(e) {
        var termino = this.state.periodo
        this.updatestate(this.state.selectidact, this.state.selectact, '', this.props.anio, this.state.periodo, 'D', this.state.observacion, termino, termino, termino, 'Nueva Carga')
        
        this.cerrarModal()
    }
    render() {

        let contents = this.state.loading
            ? <p><em>Loading...this.populateActividadesData(this.props.anio);</em></p>
            : this.renderActividadesTable(this.state.actividades);


        let contents_mat = this.state.loading2
            ? <p><em>Loading... this.populateMateriasData(this.props.anio);</em></p>
            : this.renderMateriasTable(this.state.materias);
        
        const totalpepa = this.state.materias ? this.state.materias.map(horastot => horastot.horasTotales).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const totalpepa2 = this.state.actividades ? this.state.actividades.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambitout = totalpepa + totalpepa2;
        //const talambito = this.formatter(talambitout);
        const talambito = talambitout.toLocaleString('en', { maximumFractionDigits: 2 })

        const combo = {
            width: '150px',
        };
        const buttonToLink = {
            fontSize: '0.65em',
            textAlign: 'left',
            float: 'right',
            color: '#58A7E0',
            background: 'none',
            margin: 0,
            padding: 0,
            border: 'none',
            cursor: 'pointer',
            ":hover": {
                color: "yellow"
            }
        };
        const estilo = {
            color: 'white',
            fontSize: '15px',
            marginBottom: '20px',
            fontFamily: 'Robota'
        };

        const form_nuevo = {
            fontSize: '0.65em',
            color: "darkgray"
        };

        return (
            <div> 
                 
                {contents_mat}
                
                {contents}


                <div className="inline-grid  grid-cols-1 bg-total2">
                    <div className="px-1 ">Total de Ámbito de Docencia PostGrado: {talambito} horas</div>
                </div>

            </div>
        );
    }

    async populateActividadesData(idpersona, anio) {

        //const response = await fetch(API_URL + 'TblActividades/' + idpersona + '/' + anio + '/P/D');
        //const respuesta = await response.json();
        const respuesta = this.props.cargaAct;
        const data = respuesta.filter(x => x.nivelEstudio == 'P');
        var selected = []
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idactividad: act.idactividad, validada: "", estado_actividad: "" }) })//data.map(act => { actividades.push({ ambito: 'AR', idactividad: act.idactividad, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino1 + '|' + act.termino2 + '|' + act.termino3 }) })
            data.map(act => { actividades.push({ ambito: 'A|P', idactividad: act.idactividad }) })
            var actividades2 = [];
            data.map(act => { actividades2.push({ tipo: 'A|P', idactividad: act.idactividad, anio: anio, descripcion: act.descripcion, periodo: act.termino1 + '|' + act.termino2 + '|' + act.termino3, accion: '', observacion: '', totalhoras: act.totalhoras,  validado: 1 }) })
            this.props.updateCarga(actividades, actividades2);
        }
        
        this.setState({ actividad_elegida: selected, actividades: data, loading: false });


    }


    async populateMateriasData(idpersona, anio) {
        //const response = await fetch(API_URL + 'TblMateriasPostg/' + idpersona + '/' + anio);
        //const respuesta = await response.json();
        const respuesta = this.props.cargaMat;
        //console.log("respuesta: materiasPOSTGRADO: ", respuesta);
        const data = respuesta;
        this.setState({ materias: data, loading2: false });
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idcurso: act.idCplPostGrados, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'MR', idactividad: act.idcurso, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino}) })
            data.map(act => { actividades.push({ ambito: 'M|P', idactividad: act.idCplPostGrados }) })
            var actividades2 = [];
            data.map(act => { actividades2.push({ tipo: 'M|P', idactividad: act.idCplPostGrados, anio: act.anio, descripcion: act.nomMateria, periodo: act.termino, accion: '', observacion: '', totalhoras: act.horasTotales, validado: 1 }) })
            this.props.updateCarga(actividades, actividades2);

        }

        this.setState({ materia_elegida: selected, materias: data, loading: false });

    }



    async populateActividadesCombo(idpersona, anio) {

        try {
            const response = await fetch(API_URL + 'TblActividades/' + anio + '/R/token', { signal: this.abortController.signal });
            const respuesta = await response.json();
            const data = respuesta;
            this.setState({ actividades_combo: data, loading: false });
        } catch (err) {
            if (err.name === "AbortError") { console.log("AbortError controlado"); }
		}
    }

}
Docencia_Postgrado_out.contextType = AppContext;